import { c as _c } from "react/compiler-runtime";
import React from 'react';
import buildRouteUrl from '../../helpers/buildRouteUrl';
import { Link } from '../../i18n/navigation';
import { Genre } from '../../types/types';
import GenreItem from './GenreItem';
interface PropTypes {
  data: Genre[];
  from_page: 'movie' | 'tv';
}
const GenresList: React.FC<PropTypes> = t0 => {
  const $ = _c(7);
  const {
    data,
    from_page
  } = t0;
  const selectedPage = from_page === "movie" ? "movies" : "tv";
  if (data.length > 0) {
    let t1;
    if ($[0] !== data || $[1] !== selectedPage) {
      let t2;
      if ($[3] !== selectedPage) {
        t2 = genre => <Link key={genre.id} href={buildRouteUrl(`/genres/${genre.id}/${selectedPage}`)}><GenreItem data={genre} /></Link>;
        $[3] = selectedPage;
        $[4] = t2;
      } else {
        t2 = $[4];
      }
      t1 = data.map(t2);
      $[0] = data;
      $[1] = selectedPage;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[5] !== t1) {
      t2 = <div className="flex flex-row flex-wrap gap-2 mt-4">{t1}</div>;
      $[5] = t1;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  } else {
    return null;
  }
};
export default GenresList;